import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { VehiculeCheckTypeInfosManagement } from '../components/VehiculeCheckTypeInfosManagement';
import { useNavigate } from 'react-router-dom';
import {
  TVehiculeCheckTypeSchema,
  vehiculeCheckTypeSchema,
} from '@/schemas/vehicule-check-type/vehicule-check-type.schema';
import { useCreateVehiculeCheckType } from '@/hooks/vehicule-check-type.hooks';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '@/utils/language.utils';

export const CreateVehiculeCheckType = () => {
  const { t } = useTranslation('inspectionType');
  const navigate = useNavigate();

  const {
    watch: watchVehiculeCheckType,
    control: vehiculeCheckTypeControl,
    register: registerVehiculeCheckType,
    setValue: setVehiculeCheckTypeValue,
    setError: setVehiculeCheckTypeError,
    handleSubmit: handleSubmitVehiculeCheckType,
    formState: {
      errors: vehiculeCheckTypeErrors,
      isSubmitting: isSubmittingVehiculeCheckType,
    },
  } = useForm<TVehiculeCheckTypeSchema>({
    resolver: zodResolver(vehiculeCheckTypeSchema),
  });

  const {
    mutate: mutateCreateVehiculeCheckType,
    isPending: isPendingCreateVehiculeCheckType,
  } = useCreateVehiculeCheckType({
    t,
    handleSuccess: () => navigate('/vehicule-check-types'),
  });

  const onSubmitVehiculeCheckType = (
    vehiculeCheckType: TVehiculeCheckTypeSchema
  ) => {
    const { languageCode } = getLanguage();

    const dataWithLanguageCode = {
      ...vehiculeCheckType,
      languageCode,
    };

    mutateCreateVehiculeCheckType(dataWithLanguageCode);
  };

  return (
    <>
      <PageHeader
        backToLink="/vehicule-check-types"
        title={t('common:inspectionType')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem
              text={t('inspectionTypeList')}
              linkTo="/vehicule-check-types"
            />
            <BreadcrumbItem text={t('common:inspectionType')} active />
          </BreadcrumbList>
        }
      />
      <div className="flex flex-col gap-12">
        <VehiculeCheckTypeInfosManagement<TVehiculeCheckTypeSchema>
          t={t}
          watch={watchVehiculeCheckType}
          control={vehiculeCheckTypeControl}
          register={registerVehiculeCheckType}
          setValue={setVehiculeCheckTypeValue}
          setError={setVehiculeCheckTypeError}
          errors={vehiculeCheckTypeErrors}
          submitDisabled={
            isSubmittingVehiculeCheckType || isPendingCreateVehiculeCheckType
          }
          onSubmit={handleSubmitVehiculeCheckType(onSubmitVehiculeCheckType)}
        />
      </div>
    </>
  );
};
